import React, { useEffect, useState } from 'react';
import '../Css/Colleges_Ethiccraft.css';

const Data = [
  {
    "id": "leadership-cert",
    "name": "Leadership Certification",
    "description": "Get recognized with an official certificate for your role and contribution."
  },
  {
    "id": "national-rec",
    "name": "National Recognition",
    "description": "Stand out in a growing network of student leaders from top institutions."
  },
  {
    "id": "skill-dev",
    "name": "Skill Development",
    "description": "Sharpen public speaking, event planning, teamwork, and project execution."
  },
  {
    "id": "mentor-access",
    "name": "Mentorship Access",
    "description": "Learn directly from Ethiccraft mentors and senior change-makers."
  },
  {
    "id": "priority-events",
    "name": "Priority Access to Events",
    "description": "Be the first to attend and even host key events, fests, and workshops."
  },
  {
    "id": "exclusive-training",
    "name": "Exclusive Training",
    "description": "Access personalized leadership training sessions — online or in-person."
  },
  {
    "id": "rec-letters",
    "name": "Recommendation Letters",
    "description": "Earn impactful recommendation letters for internships or further studies."
  },
  {
    "id": "opportunity-rep",
    "name": "Opportunity to Represent",
    "description": "Be the face of values-led youth leadership at your college and beyond."
  }
];

const DataShowcase = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`team-showcase-container ${isVisible ? 'fade-in' : ''}`}>
      <h1 className="team-main-title">What You Gain as a Campus Ambassador</h1>
      <div className="team-grid">
        {Data.map((member, index) => (
          <div 
            key={member.id} 
            className="team-member-card"
            style={{ animationDelay: `${index * 0.1}s` }} // Slightly faster stagger
          >
            <div className="card-border"></div>
            <div className="member-details">
              <div className="member-header">
                <h3 className="member-name">{member.name}</h3>
                <div className="member-role">Campus Ambassador</div>
              </div>
              <p className="member-bio">{member.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataShowcase;